<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <div class="grid-container">
        <div class="item1 text-uppercase d-flex">
          <h6>{{ $t("kids.kids") }}</h6>
        </div>
        <div v-if="parent.notes" class="item5 w-100">
          <span>{{ parent.notes }}</span>
        </div>
        <!-- Nova sekcija -->
        <div class="item2">
          <span class="text-uppercase">{{ $t("parents.name") }}</span
          ><span>: {{ parent.parent_name }}</span>
        </div>
        <div class="item3">
          <span class="text-uppercase">{{ $t("teachers.mobile") }}</span
          ><span>: {{ parent.mobile }}</span>
        </div>
        <div class="item4">
          <div class="d-flex fr">
            <div class="d-block">
              <img :src="parent.image" class="right-img mx-4 fr" />
            </div>
            <div class="d-block">
              <soft-badge
                color="warning"
                variant="gradient"
                size="sm"
                @click="$emit('close')"
                class="cursor-pointer fr close"
              >
                {{ $t("global.close") }}
              </soft-badge>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center justify-content-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 subcourse-title"
              >
                {{ $t("kids.name") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("kids.subscribedSubcourse") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseStartDate") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("kids.numberOfPayments") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
              >
                {{ $t("teachers.pastMonths") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("parents.unpaidInstallments") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder text-center opacity-7 ps-2"
              >
                {{ $t("teachers.detail.subcourseDuration") }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in parent.kids" :key="item.id">
              <td class="subcourse-title">
                {{ item.kid_name }}
              </td>
              <td>
                <p
                  v-for="(subcourse, index) in item.subcourse"
                  :key="index.id"
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.title }}
                </p>
              </td>
              <td>
                <p
                  v-for="subcourse in item.subcourse"
                  :key="subcourse.id"
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.start_date }}
                </p>
              </td>
              <td>
                <p
                  v-for="subcourse in item.subcourse"
                  :key="subcourse.id"
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.paid_installment }}
                </p>
              </td>
              <td>
                <p
                  v-for="subcourse in item.subcourse"
                  :key="subcourse.id"
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.number_of_finished_months }}.
                </p>
              </td>
              <td>
                <p
                  v-for="subcourse in item.subcourse"
                  :key="subcourse.id"
                  :class="
                    subcourse.debt > 0
                      ? 'mb-0 btn btn-icon-only btn-rounded me-0 btn-sm align-items-center justify-content-center btn-danger'
                      : ''
                  "
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.debt }}
                </p>
              </td>
              <td class="align-middle ps-2">
                <p
                  v-for="subcourse in item.subcourse"
                  :key="subcourse.id"
                  class="text-xs font-weight-bold"
                >
                  {{ subcourse.number_of_months }}
                  {{ this.formatMonthsTitle(subcourse.number_of_months) }}
                </p>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="#" @click="goToKid(item)">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
//import SoftProgress from "@/components/SoftProgress";
import SoftBadge from "@/components/SoftBadge.vue";

export default {
  name: "parent-details",
  components: {
    SoftBadge,
  },
  props: {
    parent: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      value: 0,
      isKidVisible: false,
    };
  },
  computed: {
    valueClass() {
      console.log(this.value);
      return this.value > 0 ? "text-red-500" : "";
    },
  },
  methods: {
    goToKid(kid) {
      this.$emit("kid", kid);
    },
    formatMonthsTitle(numberOfMonths) {
      return numberOfMonths > 4
        ? this.$t("teachers.detail.months")
        : this.$t("teachers.detail.month");
    },
  },
};
</script>

<style scoped>
.container {
  display: inline-flex;
  justify-content: flex-start;
  position: relative;
}

tr,
td {
  text-align: center;
  vertical-align: middle;
}

.subcourse-title {
  padding-left: 30px;
  text-align: left;
}

.text-red-500 {
  font-weight: bolder;
  color: #ff0000;
}

.item1 {
  grid-area: teacher-detail;
  height: 1px;
}

.item2 {
  grid-area: teachers-name;
  height: 3px;
  font-size: medium !important;
}

.item3 {
  grid-area: teachers-course;
  height: 3px;
  font-size: medium !important;
}

.item4 {
  grid-area: teachers-image;
}

.item5 {
  grid-area: teacher-info;
  width: 150px;
  font-size: small !important;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
}

.close {
  position: relative;
  float: right !important;
}

.grid-container {
  display: grid;
  grid-template-areas:
    "teacher-detail teacher-detail teacher-info  teachers-image teachers-image"
    "teachers-name teachers-name teacher-info  teachers-image teachers-image"
    "teachers-course teachers-course teacher-info  teachers-image teachers-image";
  gap: 1px;
  padding: 1px;
}

.grid-container > div {
  background-color: rgba(255, 255, 255, 0.8);
  text-align: left;
  padding: 5px 20px;
  font-size: 20px;
}

.right-img {
  position: relative;
  border: 1px solid gray;
  padding: 6px;
  border-radius: 8px;
  width: 120px !important;
  height: 120px !important;
}

.fr {
  float: right;
}
</style>
